import LogRocket from 'logrocket';

LogRocket.init('fua08n/pangea')